export default "__VITE_ASSET__WbZBs1jw__"